import { defineMessage, useIntl } from 'react-intl';

import { BasketSlotDocument } from '@packages/gql/generated/shopping/BasketSlotDocument';
import { useI18n } from '@packages/shared/src/hooks/useI18n/useI18n';
import { useConfig } from '@packages/shared/src/hooks/useConfig/useConfig';
import { getLocalizedPath } from '@packages/shared/src/utils/getLocalizedPath/getLocalizedPath';

import { useBadgeCount } from './useBadgeCount';

const title = defineMessage({
  id: 'slot.basket.displaytext',
  defaultMessage: 'Warenkorb',
});

const ariaLabelWithCount = defineMessage<{ readonly count: number | bigint }>({
  id: 'slot.basket.aria-label',
  defaultMessage: 'Warenkorb, {count, plural, one {# Artikel} other {# Artikel}}',
});

/* GraphQL */ `
  query BasketSlot($locale: String!) {
    basket(locale: $locale, skipRecalculation: true) {
      itemCount
    }
  }
`;

export const useBasketLink = () => {
  const { formatMessage } = useIntl();
  const { order } = useConfig();
  const { locale } = useI18n();

  const { badgeCount } = useBadgeCount({
    document: BasketSlotDocument,
    getCount: (data) => data?.basket?.itemCount ?? 0,
    eventNameForExternalUpdates: 'basketUpdated',
  });

  const label = formatMessage(title);

  return {
    href: getLocalizedPath(order.paths.basket, locale),
    label,
    ariaLabel: badgeCount ? formatMessage(ariaLabelWithCount, { count: badgeCount }) : label,
    badgeCount,
  };
};
